import React from 'react';

export default function Card({ title, children, dataSet = [], extra, footer }) {
  return (
    <div className="card">
      <div className="card__title">
        <span className="card__left">{title}</span>
        <If condition={extra}>{extra}</If>
      </div>
      <div className="card__slot-wrapper">
        <Choose>
          <When condition={dataSet.length > 0}>
            <div className="card-grid-wrapper">
              <For of={dataSet} each="item" index="index">
                <div className="item-wrapper">
                  <div className="label">{item.label}: </div>
                  <div className="value" style={{ maxWidth: 383 }}>
                    {item?.value ?? '-'}
                  </div>
                </div>
              </For>
            </div>
            <If condition={footer}>{footer}</If>
          </When>
          <Otherwise>{children}</Otherwise>
        </Choose>
      </div>
    </div>
  );
}
